import { createAction, props } from '@ngrx/store';

import { ContactCreateUpdate } from '@lockton-apps/shared/interfaces';

import { LsosContactActionTypes } from './types';

export const addContact = createAction(
  LsosContactActionTypes.AddContact,
  props<{ contact: ContactCreateUpdate }>()
);
